import { createSlice } from "@reduxjs/toolkit";
import type { DrillDownPageActionTypes, DrillDownPageState } from "../types/drillDownPageState.types";
import { DRILL_DOWN_PAGE_SLICE_NAME } from "../utils/storeUtils";

const initialState: DrillDownPageState = {
  pages: [],
};

const drillDownPageSlice = createSlice({
  name: DRILL_DOWN_PAGE_SLICE_NAME,
  initialState,
  reducers: {
    add(state, action: DrillDownPageActionTypes["add"]) {
      state.pages.push(action.payload);
    },

    remove(state, action: DrillDownPageActionTypes["remove"]) {
      state.pages = state.pages.filter((page) => page.pageId !== action.payload);
    },
    removeAll(state) {
      state.pages = [];
    },
    setInfo(state, action: DrillDownPageActionTypes["setInfo"]) {
      const { pageId, subLayerIndex, info } = action.payload;
      const page = state.pages.find((page) => page.pageId === pageId);
      if (!page) return;
      if (subLayerIndex !== undefined && page.layer.subLayers) {
        const subLayer = page.layer.subLayers[subLayerIndex];
        if (subLayer) {
          subLayer.info = info;
        }
      } else {
        page.layer.info = info;
      }
    },
    setSelectedSubLayer(state, action: DrillDownPageActionTypes["setSelectedSubLayer"]) {
      const { pageId, index } = action.payload;
      const page = state.pages.find((page) => page.pageId === pageId);
      if (page && page.layer.subLayers && index >= 0 && index < page.layer.subLayers.length) {
        page.layer.selectedSubLayerIndex = index;
      }
    },
    setSubLayers(state, action: DrillDownPageActionTypes["setSubLayers"]) {
      const { pageId, subLayers, formulaPreview, formulaValuesPreview } = action.payload;
      const page = state.pages.find((page) => page.pageId === pageId);
      if (page) {
        page.layer.subLayers = subLayers;
        page.layer.formulaPreview = formulaPreview;
        page.layer.formulaValuesPreview = formulaValuesPreview;
        page.layer.selectedSubLayerIndex = subLayers.findIndex((c) => !c.disabled) ?? 0;
      }
    },
  },
});

export default drillDownPageSlice.reducer;
